import { COUNTRY_OPTIONS } from '@constants/selectorsConstants';

/**
 * Converts an array of country names to their ISO codes
 * @param countryNames - Array of country names (e.g., ["Saudi Arabia", "Afghanistan"])
 * @returns Array of ISO codes (e.g., ["SA", "AF"])
 */
export const convertCountryNamesToCodes = (
  countryNames: string[],
): string[] => {
  if (!Array.isArray(countryNames) || countryNames.length === 0) {
    return [];
  }

  return countryNames
    .map(name => {
      // Search for the country by its label
      const country = COUNTRY_OPTIONS.find(
        option => option.label.toLowerCase() === name.toLowerCase(),
      );

      if (country) {
        return country.value;
      }
      return null;
    })
    .filter((code): code is string => code !== null);
};

/**
 * Converts a country name to its ISO code
 * @param countryName - Country name (e.g., "Saudi Arabia")
 * @returns ISO code (e.g., "SA") or empty string if not found
 */
export const convertCountryNameToCode = (countryName: string): string => {
  if (!countryName) return '';

  const country = COUNTRY_OPTIONS.find(
    option => option.label.toLowerCase() === countryName.toLowerCase(),
  );

  return country ? country.value : '';
};

/**
 * Converts an array of ISO codes to country names
 * @param countryCodes - Array of ISO codes (e.g., ["SA", "AF"])
 * @returns Array of country names (e.g., ["Saudi Arabia", "Afghanistan"])
 */
export const convertCountryCodesToNames = (
  countryCodes: string[],
): string[] => {
  if (!Array.isArray(countryCodes) || countryCodes.length === 0) {
    return [];
  }

  return countryCodes
    .map(code => {
      const country = COUNTRY_OPTIONS.find(option => option.value === code);

      return country ? country.label : null;
    })
    .filter((name): name is string => name !== null);
};
